export default __webpack_public_path__ + "static/media/pet-day-care.c6748a58.svg";